"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { createClient } from "@/lib/supabase/client";
import { signupHrefFor } from "@/lib/landing-signup";

type LandingTerminalLinkProps = {
  href: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

/** Terminal CTAs: signed-in users go straight in; guests get the signup gate. */
export default function LandingTerminalLink({
  href,
  className,
  style,
  children,
}: LandingTerminalLinkProps) {
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    const supabase = createClient();
    supabase.auth.getUser().then(({ data: { user } }) => {
      setAuthed(Boolean(user));
    });
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setAuthed(Boolean(session?.user));
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Link
      href={authed ? href : signupHrefFor(href)}
      className={className}
      style={style}
    >
      {children}
    </Link>
  );
}
